import { connect } from 'react-redux';
import OrganizationProfile from './OrganizationProfile';
import {
  updateOrganization,
  loadOrganization,
} from '../../../../redux/actions/user';
import { selectDepartments } from '../../../../redux/selectors/departments';
import { loadDepartments } from '../../../../redux/actions/departments';

const mapStateToProps = (state) => {
  return {
    status: state.user.status,
    organization: state.user.organization,
    departments: selectDepartments(state),
    departmentsStatus: state.departments.status,
    user: state.user.user,
  };
};

const mapDispatchToProps = {
  updateOrganization,
  loadDepartments,
  loadOrganization,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrganizationProfile);
